import React, { useEffect, useRef } from 'react';
import { useDriveStore, driveBridge, requestToggle } from './driveStore';
import { HUD_FONT, ensureHudFont } from '../hud/hudFont';

// ── THE DASH ─────────────────────────────────────────────────────────────────
// Near a car: a prompt to take it (a button on touch). In one: the speed, big,
// in the corner, and the controls once. The speed is written straight into the
// DOM from its own animation frame — no React render per frame.
export default function DriveHud({ touch = false }) {
  const near = useDriveStore((s) => s.near);
  const driving = useDriveStore((s) => s.driving);
  const mph = useRef(null);
  useEffect(() => { ensureHudFont(); }, []);

  useEffect(() => {
    if (driving == null) return undefined;
    let raf = 0;
    const tick = () => {
      raf = requestAnimationFrame(tick);
      if (mph.current) mph.current.textContent = String(driveBridge.mph || 0);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [driving]);

  const pill = {
    pointerEvents: 'auto', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
    background: 'rgba(10,12,16,0.78)', border: '1px solid rgba(255,255,255,0.16)', borderRadius: 999,
    padding: '9px 16px 9px 9px', color: '#fff', font: '700 13px system-ui', letterSpacing: 0.4,
    boxShadow: '0 8px 24px rgba(0,0,0,0.45)',
  };
  const key = { display: 'grid', placeItems: 'center', width: 26, height: 26, borderRadius: 7, background: '#ffd27d', color: '#141008', font: '900 13px system-ui' };

  if (driving == null && near == null) return null;
  return (
    <>
      {driving == null && near != null && (
        <div style={{ position: 'absolute', left: '50%', bottom: touch ? 'calc(max(16px, env(safe-area-inset-bottom)) + 150px)' : 214, transform: 'translateX(-50%)' }}>
          <button style={{ ...pill, border: 'none' }} onClick={requestToggle}>
            <span style={key}>{touch ? '▶' : 'F'}</span> Drive
          </button>
        </div>
      )}
      {driving != null && (
        <>
          <div style={{
            // Desktop: inboard of the right-hand button column (chat, phone,
            // music). Touch: top-left under the nav — the bottom corners belong
            // to the joystick and the VR / phone / music buttons.
            position: 'absolute',
            ...(touch
              ? { left: 'max(18px, env(safe-area-inset-left))', top: 'calc(max(16px, env(safe-area-inset-top)) + 56px)', textAlign: 'left' }
              : { right: 'max(92px, env(safe-area-inset-right))', bottom: 20, textAlign: 'right' }),
            pointerEvents: 'none',
          }}>
            <div ref={mph} style={{ font: `${touch ? 44 : 64}px/0.9 ${HUD_FONT}`, color: '#fff', textShadow: '2px 2px 0 #000, 0 6px 22px rgba(0,0,0,0.5)', fontStyle: 'italic' }}>0</div>
            <div style={{ font: '800 11px system-ui', letterSpacing: 4, color: '#ffd27d', textShadow: '1px 1px 0 #000' }}>MPH</div>
          </div>
          {touch ? (
            <div style={{ position: 'absolute', right: 'max(16px, env(safe-area-inset-right))', top: 'calc(max(16px, env(safe-area-inset-top)) + 60px)' }}>
              <button style={{ ...pill, border: 'none' }} onClick={requestToggle}><span style={key}>⏏</span> Exit</button>
            </div>
          ) : (
            <div style={{
              position: 'absolute', left: '50%', bottom: 24, transform: 'translateX(-50%)', pointerEvents: 'none',
              color: 'rgba(255,255,255,0.78)', font: '600 12px system-ui', letterSpacing: 0.4, whiteSpace: 'nowrap',
              background: 'rgba(10,12,16,0.55)', borderRadius: 999, padding: '7px 14px',
            }}>
              <b>W/S</b> drive · <b>A/D</b> steer · <b>Space</b> handbrake · drag to look · <b>F</b> get out · hold <b>Q</b> radio
            </div>
          )}
        </>
      )}
    </>
  );
}
